
import React from 'react';
import { Helmet } from 'react-helmet';
import './pagestyles/RedboxCompilance.css';

const RedboxCompliance = () => {
  return (
    <>
      <Helmet>
        <title>Redbox Compliance - Regulatory Compliance & Governance Solutions | Redbox Global</title>
        <meta
          name="description"
          content="Redbox Compliance provides regulatory reporting, surveillance, governance, and compliance tools for financial institutions."
        />
        <meta
          name="keywords"
          content="Redbox Compliance, regulatory compliance, governance, surveillance, financial regulation, reporting, risk and compliance"
        />

        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://redboxglobal.com/compliance" />
        <meta property="og:title" content="Redbox Compliance - Regulatory & Governance Platform" />
        <meta
          property="og:description"
          content="Ensure regulatory compliance and governance with Redbox Compliance tools."
        />
        <meta
          property="og:image"
          content="https://images.unsplash.com/photo-1553877522-43269d4ea984?w=1200&h=630&fit=crop"
        />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Redbox Compliance - Regulatory Platform" />
        <meta
          name="twitter:description"
          content="Professional compliance and governance tools for financial institutions."
        />
        <meta
          name="twitter:image"
          content="https://images.unsplash.com/photo-1553877522-43269d4ea984?w=1200&h=630&fit=crop"
        />

        <link rel="canonical" href="https://redboxglobal.com/compliance" />

        {/* Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "SoftwareApplication",
            "name": "Redbox Compliance",
            "applicationCategory": "FinanceApplication",
            "operatingSystem": "Web",
            "description":
              "Compliance and governance platform for regulatory reporting, surveillance, and oversight.",
            "url": "https://redboxglobal.com/compliance",
            "publisher": {
              "@type": "Organization",
              "name": "Redbox Global"
            }
          })}
        </script>
      </Helmet>

      <div className="page-container">
        <div className="page-header">
          <h1>Redbox Compliance</h1>
          <p className="page-subtitle">
            Regulatory compliance, governance, and surveillance for modern financial institutions
          </p>
        </div>

        <div className="page-content">
          {/* Featured Article */}
          <a
            href="/article/redbox-compliance-overview"
            style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
          >
            <div className="featured-article">
              <div className="featured-image">
                <img
                  src="https://images.unsplash.com/photo-1553877522-43269d4ea984?w=1200&h=600&fit=crop"
                  alt="Compliance and governance platform"
                />
              </div>
              <div className="featured-content">
                {/* <span className="article-category">Compliance Platform</span> */}
                <h2>Stay Compliant in a Rapidly Evolving Regulatory Landscape</h2>
                <p>
                  Redbox Compliance helps financial institutions meet regulatory obligations with
                  confidence through automated reporting, trade surveillance, governance tools,
                  and real-time oversight.
                </p>
                <span className="article-meta">Explore Compliance</span>
              </div>
            </div>
          </a>

          {/* Article Cards */}
          <div className="content-grid">
            <a
              href="/article/regulatory-reporting"
              style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
            >
              <article className="article-card">
                <div className="article-image">
                  <img
                    src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=600&h=400&fit=crop"
                    alt="Regulatory reporting"
                  />
                </div>
                <div className="article-content">
                  {/* <span className="article-category">Reporting</span> */}
                  <h2>Automated Regulatory Reporting</h2>
                  <p>
                    Generate accurate regulatory reports across jurisdictions with automated,
                    auditable workflows.
                  </p>
                  <span className="article-meta">View Reporting</span>
                </div>
              </article>
            </a>

            <a
              href="/article/trade-surveillance"
              style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
            >
              <article className="article-card">
                <div className="article-image">
                  <img
                    src="https://images.unsplash.com/photo-1507679799987-c73779587ccf?w=600&h=400&fit=crop"
                    alt="Trade surveillance"
                  />
                </div>
                <div className="article-content">
                  {/* <span className="article-category">Surveillance</span> */}
                  <h2>Trade Surveillance & Market Abuse Detection</h2>
                  <p>
                    Detect suspicious activity using real-time surveillance and advanced analytics
                    to meet global compliance standards.
                  </p>
                  <span className="article-meta">Monitor Activity</span>
                </div>
              </article>
            </a>

            <a
              href="/article/governance-controls"
              style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
            >
              <article className="article-card">
                <div className="article-image">
                  <img
                    src="https://images.unsplash.com/photo-1553877522-43269d4ea984?w=600&h=400&fit=crop"
                    alt="Governance and controls"
                  />
                </div>
                <div className="article-content">
                  {/* <span className="article-category">Governance</span> */}
                  <h2>Governance, Controls & Audit Readiness</h2>
                  <p>
                    Strengthen internal controls and maintain audit readiness with centralized
                    governance and compliance management tools.
                  </p>
                  <span className="article-meta">Ensure Governance</span>
                </div>
              </article>
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default RedboxCompliance;
